// extracted by mini-css-extract-plugin
export default {"list":"Breadcrumbs_list__G5Hhy","item":"Breadcrumbs_item__Cw5Oe","last":"Breadcrumbs_last__q5N2H"};